import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";
import { EBMHeaderResponse } from "./GwEvaluarRiesgoEBS";

export function EjecutarRemoteBookingRest_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "EjecutarRemoteBookingRest",
    rutaEndPoint: "/EnterpriseServices/Sel/EjecutarRemoteBookingRest",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

export function builtEjecutarRemoteBookingRestInput(l_EjecutarRemoteBookingRequest: EjecutarRemoteBookingRequest) {
  var retorno: EjecutarRemoteBookingRest_Entrada = {
    EjecutarRemoteBookingRequest: l_EjecutarRemoteBookingRequest,

  }

  return retorno;
}

// 
export interface EjecutarRemoteBookingRest_Entrada {
  EjecutarRemoteBookingRequest: EjecutarRemoteBookingRequest;

}

export interface EjecutarRemoteBookingRequest {
  IdentificadorCanalUnico: string;
  NumeroCuenta: string;
  NumeroComercial: string;
  Grupo: string; // Remote Booking
  Origen: string; // Web
  UserName: string; // email
  FechaInicio: string; // ""
  OriginalNetwork: string;
  Categoria: string; // paquete
  TipoContenido: string; // "Episodio" / "Serie"
  ContentProvider: string;
  TipoGrabacion: string;
  SessionID: string;
  Tipo: string; // Remote Booking
  EventId: string;
  Pais: string;
  FechaFin: string; // ""
  TarjetaInteligente: string;
  Recordatorio: string; // "Y" | "N"
  SistemaOrigen: string; // Web
  ProgramId: string;
  ContentId: string;
  Recurrencia: string; // ""
  Duracion: string; // minutos ??
  NombreEvento: string;
  NombreCanal: string;
  Operacion: string; // "Solicitud Servicio Integrada"
  TransportStream: string;
  SeriesId: string;
}

export interface EjecutarRemoteBookingResponse {
  SRNumber: string;
  SREstatus: string;
  SRSubestatus: string;
}

export interface EjecutarRemoteBookingResponse {
  EjecutarRemoteBookingResponse: EjecutarRemoteBookingResponse;
}

export type EjecutarRemoteBookingRest_Respuesta = EncabezadoRespuestaInterna  & EjecutarRemoteBookingResponse


